import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { $ as $f7dceffc5ad7768b$export$4e328f61c538687f } from '../3rdPartyModules/_react-aria/focus/dist/useFocusRing-BO5gj-B1.js';
import { $ as $3ef42575df84b30b$export$9d1611c77c2fe928 } from '../3rdPartyModules/_react-aria/utils/dist/mergeProps-DMtmc2Zw.js';
import { C as Card } from '../Card/Card-kFoh6II7.js';
import { f as focusOutline } from '../FocusIndicator/styleMixins/focusOutline-DNwtedBp.js';
import { C as Content } from './Content/Content-CoRXHzrH.js';
import { T as TaktIdConsumer } from '../TaktIdContext/TaktIdContext-DlOuPWuU.js';
import { c as createStormTaktId } from '../TaktIdContext/TaktIdContext.utils-DaCk9T1Y.js';
import { D as DefaultTitle } from './DefaultTitle/DefaultTitle-DpRSUV5N.js';
import { D as DefaultFooter } from './DefaultFooter/DefaultFooter-Cs4wtNqg.js';
import { D as DefaultBody } from './DefaultBody/DefaultBody-BcthPUSh.js';
import { D as DefaultImage } from './DefaultImage/DefaultImage-C79z9dQp.js';

const StyledTitle = /*#__PURE__*/styled('span').withConfig({
  componentId: "sc-storm-ui-30065889__sc-p8lviz-0"
})(["word-break:break-word;"]);
const StyledCard = /*#__PURE__*/styled(Card).withConfig({
  componentId: "sc-storm-ui-30065889__sc-p8lviz-1"
})(["", ""], ({
  $isSelected,
  theme
}) => $isSelected && {
  'background-color': theme.card.selected.bg,
  'border-color': theme.card.selected.borderColor
});
const FooterContainer = /*#__PURE__*/styled.button.attrs(props => {
  const {
    isFocusVisible,
    focusProps
  } = $f7dceffc5ad7768b$export$4e328f61c538687f();
  return {
    ...$3ef42575df84b30b$export$9d1611c77c2fe928(props, focusProps),
    focusVisible: isFocusVisible,
    type: 'button'
  };
}).withConfig({
  componentId: "sc-storm-ui-30065889__sc-p8lviz-2"
})(["", " color:inherit;background-color:unset;border:unset;width:100%;text-align:start;padding:", ";cursor:pointer;border-radius:", ";:focus{", "}:active{color:unset;}"], ({
  theme
}) => theme.typography.base, ({
  theme
}) => theme.spacing.small, ({
  theme
}) => `0 0 ${theme.card.radius} ${theme.card.radius}`, ({
  focusVisible
}) => focusVisible && focusOutline);
FooterContainer.displayName = 'FooterContainer';
const CardListItem = ({
  id,
  className,
  isSelected,
  onSelect,
  onClick,
  title,
  footer,
  onFooterClick,
  ariaLabel,
  children,
  taktId,
  taktValue,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(StyledCard, {
  className: className,
  id: id,
  padding: "none",
  $isSelected: isSelected,
  taktId: taktId
}, /*#__PURE__*/React__default.createElement(Content, _extends({}, restProps, {
  id: id,
  isSelected: isSelected,
  onSelect: onSelect,
  onClick: onClick,
  ariaLabel: ariaLabel
}), /*#__PURE__*/React__default.createElement(StyledTitle, null, title), children), footer && /*#__PURE__*/React__default.createElement(TaktIdConsumer, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('card-footer')
}, ({
  getDataTaktAttributes
}) => /*#__PURE__*/React__default.createElement(FooterContainer, _extends({}, getDataTaktAttributes(), {
  onClick: event => onFooterClick && onFooterClick(event)
}), footer)));
CardListItem.defaultProps = {
  className: '',
  onSelect: undefined,
  isSelected: false,
  onClick: undefined,
  title: undefined,
  footer: undefined,
  onFooterClick: undefined
};
CardListItem.DefaultTitle = DefaultTitle;
CardListItem.DefaultFooter = DefaultFooter;
CardListItem.DefaultBody = DefaultBody;
CardListItem.DefaultImage = DefaultImage;

export { CardListItem as C };
//# sourceMappingURL=CardListItem-Dci4Sq-7.js.map
